// import React from "react";
// import "../Style/releaseNote.css";
// import ReleaseBanner from "../Components/ReleaseBanner";
// import ReleaseInfo from "../Components/ReleaseInfo";
// const ReleaseNote = () => {
//   return (
//     <>
//       <ReleaseBanner />
//       <ReleaseInfo />
//     </>
//   );
// };

// export default ReleaseNote;
import React from "react";
import { getSEOData } from "../../../global/utils/constants/seoConfig";
import SEO from "../../../global/components/SEO/SEO";
import "../Style/releaseNote.css";
import ReleaseBanner from "../Components/ReleaseBanner";
import ReleaseInfo from "../Components/ReleaseInfo";

const ReleaseNote = () => {
  const seoData = getSEOData("/releasenote");

  return (
    <>
      <SEO
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
        type="website"
      />
      <ReleaseBanner />
      <ReleaseInfo />
    </>
  );
};

export default ReleaseNote;